export default __webpack_public_path__ + "static/media/unjoined.84eb27cc.png";